import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

export const PublicNav = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const links = [
    { to: "/services/commercial", label: "Commercial" },
    { to: "/services/passenger", label: "Passenger" },
    { to: "/services/custom", label: "Custom Builds" },
    { to: "/portal", label: "Customer Portal" },
  ];
  return (
    <nav className="sticky top-0 z-50 bg-[#09090b]/90 backdrop-blur border-b border-zinc-800">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <span className="bg-white rounded-md px-3 py-1.5 inline-flex items-center">
            <img src="/jd-logo.png" alt="J&D Truck Repair" className="h-8 w-auto" />
          </span>
        </Link>
        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/ /g, "-")}`}
              className={`text-sm font-semibold uppercase tracking-wide transition-colors duration-150 hover:text-yellow-500 ${pathname === l.to ? "text-yellow-500" : "text-zinc-300"}`}>
              {l.label}
            </Link>
          ))}
          <Link to="/request-quote" data-testid="nav-request-quote"
            className="bg-yellow-500 text-black font-bold uppercase text-sm px-5 py-2 hover:bg-yellow-300 transition-colors duration-150">
            Request Quote
          </Link>
        </div>
        <button className="md:hidden text-yellow-500" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-zinc-800 px-6 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-sm font-semibold uppercase text-zinc-300">{l.label}</Link>
          ))}
          <Link to="/request-quote" onClick={() => setOpen(false)} className="bg-yellow-500 text-black font-bold uppercase text-sm px-5 py-2 text-center">Request Quote</Link>
        </div>
      )}
    </nav>
  );
};

export const Footer = () => (
  <footer className="border-t border-zinc-800 bg-black mt-24">
    <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-3 gap-10">
      <div>
        <div className="mb-4">
          <span className="bg-white rounded-md px-4 py-2 inline-flex">
            <img src="/jd-logo.png" alt="J&D Truck Repair" className="h-12 w-auto" />
          </span>
        </div>
        <p className="text-zinc-400 text-sm">Commercial, passenger vehicles and custom builds.</p>
      </div>
      <div>
        <p className="text-xs font-bold tracking-[0.2em] uppercase text-zinc-500 mb-3">Contact</p>
        <p className="text-zinc-300 text-sm">120 N Rockwell Ave D105</p>
        <p className="text-zinc-300 text-sm">Oklahoma City, OK 73127</p>
        <a href="tel:4052197625" className="text-yellow-500 font-semibold text-sm block mt-2">Call or text: 405-219-7625</a>
        <a href="mailto:jdtruckrepair@hotmail.com" className="text-yellow-500 font-semibold text-sm block mt-1">jdtruckrepair@hotmail.com</a>
      </div>
      <div>
        <p className="text-xs font-bold tracking-[0.2em] uppercase text-zinc-500 mb-3">Staff</p>
        <Link to="/staff/login" className="text-zinc-300 text-sm hover:text-yellow-500 transition-colors duration-150">Staff Portal Login →</Link>
      </div>
    </div>
    <div className="border-t border-zinc-800 py-4 text-center text-zinc-600 text-xs">© {new Date().getFullYear()} J&amp;D Truck Repair. All rights reserved.</div>
  </footer>
);
